import { render, staticRenderFns } from "./productSelectFull.vue?vue&type=template&id=894f2d92&"
import script from "./productSelectFull.vue?vue&type=script&lang=js&"
export * from "./productSelectFull.vue?vue&type=script&lang=js&"
import style0 from "./productSelectFull.vue?vue&type=style&index=0&id=894f2d92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports